module.exports = "uniform float c;\nuniform float p;\nvarying vec3 vNormal;\nuniform float opacity;\nvoid main()\n{\n  float intensity = pow( c - dot( vNormal, vec3( 0.0, 0.0, 1.0 ) ), p );\n  gl_FragColor = vec4( 1.0, 1.0, 1.0, 1.0 ) * intensity * opacity;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/components/Parts/Key3D/WoozyShaders/AlexGlow.frag
// module id = 359
// module chunks = 0